export function getVersionReadiness(version) {
  const classification = version?.classification || {};
  const reviewItems = Array.isArray(classification.review_items)
    ? classification.review_items
    : [];
  const highSeverityGaps = Array.isArray(version?.compliance_gaps)
    ? version.compliance_gaps.filter((gap) => {
        const capa = gap?.capa || {};
        const documentedClosure = capa.status === "closed"
          && String(capa.owner || "").trim()
          && String(capa.evidence || "").trim();
        return gap?.severity === "high" && !documentedClosure;
      })
    : [];
  const classificationNeedsReview = Boolean(
    !classification.suggested_class
    || classification.needs_human_review
    || classification.classification_status === "needs_review"
    || (typeof classification.input_completeness === "number" && classification.input_completeness < 1)
    || reviewItems.length,
  );
  const ready = Boolean(version)
    && !classificationNeedsReview
    && highSeverityGaps.length === 0;

  return {
    ready,
    classificationNeedsReview,
    reviewItems,
    highSeverityGaps,
    pendingCount: reviewItems.length + highSeverityGaps.length,
  };
}
